import { createRoot } from "react-dom/client";

import App from "./App.jsx";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

import "nprogress/nprogress.css";
import "./theme/nprogress.css";
import { SidebarProvider } from "./contexts/SidebarContext.jsx";

const container = document.getElementById("root");
const root = createRoot(container);


root.render(
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>
);